<div>
    <app-checkbox
        [value]="callbackData[0]?.arg[0]"
        [checked]="callbackData[1]?.arg ? callbackData[1].arg : false"
        (checkboxChange)="checkboxChanged($event)"
        (click)="onClick()"
        [disabled]="callbackData[0]?.arg[4] === false"
    >
    </app-checkbox>
    <span class="tooltipCurate" [ngClass]="showCurattionTooltip ? '' : 'tooltipCurate--hidden'">
        Curation Is Not Available
    </span>
</div>
